export default function AllInOneSection({ t }) {
  return (
    <section className="py-16 bg-gray-50" data-testid="allinone-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.allInOne.title}</h2>
        <p className="text-base text-gray-500 mb-8">{t.allInOne.subtitle}</p>
        <div className="flex flex-wrap justify-center gap-3 mb-6">
          {t.allInOne.items.map((item, i) => (
            <span key={i} className="bg-white border border-[#CDA34F]/30 rounded-full px-5 py-2 text-sm font-semibold text-gray-700 shadow-sm">{item}</span>
          ))}
        </div>
        <p className="text-sm font-bold text-[#CDA34F] uppercase tracking-wider">{t.allInOne.connected}</p>
      </div>
    </section>
  );
}
